export enum EServerDefinition {
  RMBT = 'RMBT',
  RMBTws = 'RMBTws',
  QoS = 'QoS'
}
